module.exports = require("@mui/lab/TreeItem");